import currency from 'currency.js';

var formatters = {

	/**
	 * CleanString2CorrectNumber formatter
	 *
	 * Maakt een string schoon en geeft een string terug met daarin een getal met twee decimalen met een punt als separator
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	cleanString2CorrectNumber: function(value) {
		if (typeof value !== 'undefined' && value !== null) {
			value = value.toString();
			value = value.replace(/\,/g, '.'); // Vervang alle komma's voor een punt
			value = value.replace(/[^0-9.]/g, ''); // Verwijder alles behalve cijfers en punten
			var last = value.lastIndexOf('.'); // Verkrijg de positie van de laatste punt
			var butLast = value.substring(0, last).replace(/\./g, ''); // Verwijder alle punten uit het deel van de string voor de komma
			if (butLast !== '') {
				value = butLast + value.substring(last, (last + 3)); // Plak deel voor en na de komma weer aan elkaar
			} else {
				value = butLast + value.substring(last); // Plak deel voor en na de komma weer aan elkaar
			}
		} else {
			value = '';
		}
		return value;
	},

	/**
	 * CleanNaN formatter
	 *
	 * Geeft een lege string terug als de string 'NaN' is
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	cleanNaN: function(value) {
		if ((value.indexOf('NaN') > -1)) {
			value = '';
		}
		return value;
	},

	/**
	 * Sanitizer
	 *
	 * Sanitize een string
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	sanitizeString: function(value) {

		var replaceArray = [
			['get ', 'get. '],
			['&', ' en '],
			['€', 'EUR'],
			['  ', ' ']
		];

		replaceArray.forEach(function(item) {
			value = value.replace(item[0], item[1]);
		});

		return value;
	},

	/**
	 * Commatodot formatter
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	commaToDot: function(value) {
		value = value.replace(/\,/g, '.');
		return value;
	},

	/**
	 * Currency base formatter
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	currencyBase: function(value, separator, symbol, decimal) {
		value = value || '';
		value = value.toString();
		value = value.trim();
		var outputValue = value;
		outputValue = formatters.cleanString2CorrectNumber(outputValue);
		outputValue = outputValue.replace('.', ',');
		outputValue = currency(outputValue, {
			decimal: decimal,
			separator: separator,
			symbol: symbol,
		});
		outputValue = outputValue.format();
		outputValue = formatters.cleanNaN(outputValue);
		if ('' !== outputValue && '-' === value.charAt(0)) {
			outputValue = '-' + outputValue;
		}
		return outputValue;
	},

	/**
	 * Currency formatter
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	currency: function(value) {
		value = formatters.currencyBase(value, '.', '', ',');
		return value;
	},

	/**
	 * Currency formatter with no separator
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	currencyNoSeparator: function(value) {
		value = formatters.currencyBase(value, '', '', ',');
		return value;
	},

	/**
	 * Currency with euro sign formatter
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	currencyEuroSign: function(value) {
		value = formatters.currencyBase(value, '.', '€ ', ',');
		return value;
	},

	/**
	 * Dottocomma formatter
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	dotToComma: function(value) {
		value = value.replace('.', ',');
		return value;
	},

	/**
	 * Lowercase formatter
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	lowerCase: function(value) {
		value = value.toLowerCase();
		return value;
	},

	/**
	 * Nulltoemptystring formatter
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	nullToEmptyString: function(value) {
		if (value == null) {
			value = '';
		}
		return value;
	},

	/**
	 * Percentage formatter
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	percentage: function(value) {
		value = value.toString();
		value = formatters.dotToComma(value);
		return value;
	},

	/**
	 * Percentage with two decimals formatter
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	percentageTwoDecimalsMax100: function(value) {
		if (value != null) {
			if ((value.indexOf('-') > -1)) {
				value = 0;
			}
			value = formatters.cleanString2CorrectNumber(value);
			if (parseFloat(value) > 100) {
				value = 100;
			} else if (parseFloat(value) < 0) {
				value = 0;
			}
			value = formatters.dotToComma(value.toString());
		}
		return value;
	},

	/**
	 * Removespaces formatter
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	removeSpaces: function(value) {
		value = value.replace(/\s/g, '');
		return value;
	},

	/**
	 * Spacetounderscore formatter
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	spaceToUnderscore: function(value) {
		value = value.replace(' ', '_');
		return value;
	},

	/**
	 * Uppercase formatter
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	upperCase: function(value) {
		value = value.toUpperCase();
		return value;
	},

	/**
	 * Uppercasefirst formatter
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	upperCaseFirst: function(value) {
		value = value.charAt(0).toUpperCase() + value.slice(1);
		return value;
	},

};

export default formatters;
